<template>
  <EllipsisMenu
    :id="id"
    :menu-items="menuItems"
    :disabled="disabled"
    class="shipment-menu"
  />
</template>

<script lang="ts" setup>
import { PrimeIcons } from '@primevue/core/api';
import type { PropType, Ref } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  type RygenMenuItem as RygenMenuItemModel,
  Severity,
} from '@rygen/rygen-ui/model';

import { ProposedShipment, RemoveShipmentPayload } from '@/model/routeBuilder';
import { RoutePlanProposedShipment } from '@/model/routeBuilder/phase2';

import EllipsisMenu from '@rygen/rygen-ui/components/ui/EllipsisMenu.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  proposedShipment: {
    type: Object as PropType<ProposedShipment | RoutePlanProposedShipment>,
    default: () => new ProposedShipment(),
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
});
const { id, proposedShipment, disabled } = toRefs(props);
const emit = defineEmits<{
  (event: 'remove', payload: RemoveShipmentPayload): void;
}>();

const { t } = useI18n();

const menuItems: Ref<RygenMenuItemModel[]> = computed(() => {
  return [
    {
      label: t('common.removeParam', { param: t('shipments.shipments') }),
      icon: PrimeIcons.MINUS,
      severity: Severity.DANGER,
      command: () =>
        emit('remove', {
          shipmentIdentifiers: [proposedShipment.value.identifier],
        }),
    },
  ];
});
</script>
